import React from 'react';
import { Handle } from 'reactflow';

// The trigger node is fixed for every flow and intentionally non-editable:
// it exposes no edit menu and ignores clicks for opening the config panel.
const TriggerNode = ({ data, selected }) => {
  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          background: 'white',
          borderRadius: '8px',
          border: selected ? '2px solid #667eea' : '1px solid #e2e8f0',
          overflow: 'visible',
          cursor: 'pointer',
          position: 'relative',
        }}
      >
        <div className="nodrag" style={{
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderBottom: '1px solid #e2e8f0',
          position: 'relative',
        }}>
          <div style={{
            width: '24px', height: '24px', borderRadius: '50%',
            background: '#1a202c', display: 'flex', alignItems: 'center',
            justifyContent: 'center', color: 'white', fontSize: '12px',
          }}>⚡</div>
          <span style={{ fontWeight: '600', fontSize: '14px', flex: 1 }}>{data.label}</span>
        </div>
        <div style={{ padding: '12px 16px', fontSize: '12px', color: '#718096' }}>
          {data.subtitle}
        </div>
      </div>

      <Handle type="source" position="bottom" style={{ background: '#cbd5e0' }} />
      <Handle type="source" position="right" id="right-source" style={{ background: '#cbd5e0' }} />
    </div>
  );
};

export default TriggerNode;
